import { AfterContentInit, ChangeDetectionStrategy, Component, ContentChildren, EventEmitter, Output, QueryList } from '@angular/core';
import { SubscriptionComponent } from '@liebherr/old-sage-ui';
import { ActionMenuItemComponent } from './action-menu-item/action-menu-item.component';

@Component({
    selector: 'liebherr-action-menu',
    templateUrl: 'action-menu.component.html',
    styleUrls: ['action-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActionMenuComponent extends SubscriptionComponent implements AfterContentInit {
    @Output() action = new EventEmitter<string>();
    @ContentChildren(ActionMenuItemComponent) items?: QueryList<ActionMenuItemComponent>;

    constructor() {
        super();
    }

    ngAfterContentInit() {
        this.createMenuItemListener();
    }

    private createMenuItemListener() {
        (this.items?.toArray() || [])
            .map((i) => i.action)
            .forEach((action) => {
                this.sub.add(action.subscribe((event) => this.onAction(event)));
            });
    }
    private onAction(action: string) {
        this.action.emit(action);
    }
}
